'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = blockRendererFunc;

var _draftJs = require('draft-js');

var _Image = require('./Image');

var _Image2 = _interopRequireDefault(_Image);

var _Custom = require('./Custom');

var _Custom2 = _interopRequireDefault(_Custom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function blockRendererFunc(setEditorState, getEditorState, customBlockConfig, imageUploader) {
    return function (block) {
        if (block.getType() === 'atomic') {
            var entityKey = block.getEntityAt(0);
            if (entityKey) {
                var entity = _draftJs.Entity.get(entityKey);
                if (entity && entity.type === 'IMAGE') {
                    return {
                        component: _Image2.default,
                        editable: false,
                        props: {
                            setEditorState: setEditorState,
                            getEditorState: getEditorState,
                            imageUploader: imageUploader
                        }
                    };
                }
                if (entity && entity.type === 'CUSTOM') {
                    return {
                        component: _Custom2.default,
                        editable: false,
                        props: {
                            setEditorState: setEditorState,
                            getEditorState: getEditorState,
                            customBlockConfig: customBlockConfig
                        }
                    };
                }
            }
        }
        return undefined;
    };
} // @file: Custom Block Func file
// @auth: spc@data.me 2017/10/10
// @modified: spc@data.me 2017/10/16
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/src/blocks/index.js
// module id = 128
// module chunks = 0